import { popperContentEmits as J, popperContentProps as L } from "./index569.js";
import { defineComponent as U, inject as V, provide as C, onMounted as W, watch as u, unref as e, onBeforeUnmount as Y, openBlock as Z, createElementBlock as z, mergeProps as G, createVNode as H, withCtx as Q, renderSlot as X } from "vue";
import ee from "./index570.js";
import { POPPER_CONTENT_INJECTION_KEY as oe } from "./index558.js";
import { usePopperContentFocusTrap as te } from "./index571.js";
import { usePopperContent as re } from "./index572.js";
import { usePopperContentDOM as ne } from "./index573.js";
import { formItemContextKey as F } from "./index574.js";
import { NOOP as E } from "./index575.js";
import { isElement as A } from "./index565.js";
import se from "./index567.js";
var Pe = /* @__PURE__ */ U({
  name: "ElPopperContent",
  __name: "content",
  props: L,
  emits: J,
  setup(m, { expose: b, emit: I }) {
    const T = I, o = m, {
      focusStartRef: g,
      trapped: i,
      onFocusAfterReleased: N,
      onFocusAfterTrapped: O,
      onFocusInTrap: S,
      onFocusoutPrevented: y,
      onReleaseRequested: M
    } = te(o, T), { attributes: w, arrowRef: x, contentRef: s, styles: q, instanceRef: B, role: f, update: $ } = re(o), {
      ariaModal: h,
      arrowStyle: k,
      contentAttrs: K,
      contentClass: _,
      contentStyle: d,
      updateZIndex: j
    } = ne(o, {
      styles: q,
      attributes: w,
      role: f
    }), c = V(F, void 0);
    C(oe, {
      arrowStyle: k,
      arrowRef: x
    }), c && C(F, {
      ...c,
      addInputId: E,
      removeInputId: E
    });
    let r;
    const v = (n = !0) => {
      $(), n && j();
    }, D = () => {
      v(!1), o.visible && o.focusOnShow ? i.value = !0 : o.visible === !1 && (i.value = !1);
    };
    return W(() => {
      u(
        () => o.triggerTargetEl,
        (n, a) => {
          r?.(), r = void 0;
          const t = e(n || s.value), l = e(a || s.value);
          A(t) && (r = u(
            [f, () => o.ariaLabel, h, () => o.id],
            (p) => {
              ["role", "aria-label", "aria-modal", "id"].forEach((R, P) => {
                se(p[P]) ? t.removeAttribute(R) : t.setAttribute(R, p[P]);
              });
            },
            { immediate: !0 }
          )), l !== t && A(l) && ["role", "aria-label", "aria-modal", "id"].forEach((p) => {
            l.removeAttribute(p);
          });
        },
        { immediate: !0 }
      ), u(() => o.visible, D, { immediate: !0 });
    }), Y(() => {
      r?.(), r = void 0, s.value = void 0;
    }), b({
      /**
       * @description popper content element
       */
      popperContentRef: s,
      /**
       * @description popperjs instance
       */
      popperInstanceRef: B,
      /**
       * @description method for updating popper
       */
      updatePopper: v,
      /**
       * @description content style
       */
      contentStyle: d
    }), (n, a) => (Z(), z(
      "div",
      G({
        ref_key: "contentRef",
        ref: s
      }, e(K), {
        style: e(d),
        class: e(_),
        tabindex: "-1",
        onMouseenter: a[0] || (a[0] = (t) => n.$emit("mouseenter", t)),
        onMouseleave: a[1] || (a[1] = (t) => n.$emit("mouseleave", t))
      }),
      [
        H(e(ee), {
          loop: m.loop,
          trapped: e(i),
          "trap-on-focus-in": !0,
          "focus-trap-el": e(s),
          "focus-start-el": e(g),
          onFocusAfterTrapped: e(O),
          onFocusAfterReleased: e(N),
          onFocusin: e(S),
          onFocusoutPrevented: e(y),
          onReleaseRequested: e(M)
        }, {
          default: Q(() => [
            X(n.$slots, "default")
          ]),
          _: 3
          /* FORWARDED */
        }, 8, ["loop", "trapped", "focus-trap-el", "focus-start-el", "onFocusAfterTrapped", "onFocusAfterReleased", "onFocusin", "onFocusoutPrevented", "onReleaseRequested"])
      ],
      16
      /* FULL_PROPS */
    ));
  }
});
export {
  Pe as default
};
